import { bible_note, type PowerSyncDrizzleDB } from "@bso/powersync";
import { patchRowVerified } from "../powersync/verified-write";

/**
 * UPDATE writes on `bible_note` — same window as
 * `../highlights/mutations.ts` (ver `../powersync/verified-write.ts`). El
 * user usually edits/deletes/undoes a note seconds after
 * creating it (edit drawer opened immediately after saving). Extracted
 * de `apps/web/src/routes/_app/notes.tsx` y `profile.trash.tsx`.
 */

/** Overwrites content + color of an EXISTING note (edit and its undo). */
export async function updateNoteContentMutation(
  db: PowerSyncDrizzleDB,
  id: string,
  text: string,
  color: string,
): Promise<void> {
  await patchRowVerified(db, bible_note, bible_note.id, id, {
    text_content: text,
    color,
    updated_at: new Date().toISOString(),
  });
}

/** Soft delete of a note. */
export async function softDeleteNoteMutation(db: PowerSyncDrizzleDB, id: string): Promise<void> {
  const now = new Date().toISOString();
  await patchRowVerified(db, bible_note, bible_note.id, id, {
    deleted_at: now,
    updated_at: now,
  });
}

/** Inversa de {@link softDeleteNoteMutation} (undo / papelera). */
export async function restoreNoteMutation(db: PowerSyncDrizzleDB, id: string): Promise<void> {
  await patchRowVerified(db, bible_note, bible_note.id, id, {
    deleted_at: null,
    updated_at: new Date().toISOString(),
  });
}
